import script from "./cooperativePartner.vue?vue&type=script&lang=ts&setup=true"
export * from "./cooperativePartner.vue?vue&type=script&lang=ts&setup=true"

import "./cooperativePartner.vue?vue&type=style&index=0&id=26a2600d&lang=scss&scoped=true"

import exportComponent from "D:\\yuntian\\eso\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-26a2600d"]])

export default __exports__